import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sendFrontAction } from '../services/api';
import './GetOfferMoto.css';

const STATIC_OPTIONS = [
    { value: 'other', label: 'Другая модель' },
    { value: 'undecided', label: 'Пока выбираю' },
];

const PAYMENT_OPTIONS = [
    'Полная оплата',
    'Рассрочка',
    'Рассматриваю оба варианта',
];

const GetOfferMoto = () => {
    const [motoOptions, setMotoOptions] = useState(STATIC_OPTIONS);
    const [form, setForm] = useState({
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        interested_car: '',
        custom_car_name: '',
        payment_method: '',
        comment: '',
    });
    const [status, setStatus] = useState('idle');
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        sendFrontAction('get_offer', { vehicle: 'moto' }, 'GET')
            .then((data) => {
                if (data && data.success && Array.isArray(data.data)) {
                    const dynamicOptions = data.data.map((item) => ({
                        value: `${item.type}_${item.id}`,
                        label: item.name,
                    }));
                    setMotoOptions([...dynamicOptions, ...STATIC_OPTIONS]);
                }
            })
            .catch((err) => {
                console.error('Не удалось загрузить список мотоциклов для рассрочки:', err);
            });
    }, []);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        setErrorMessage('');
        try {
            const data = await sendFrontAction('get_offer', {
                vehicle: 'moto',
                type: 'moto',
                ...form,
            }, 'POST');

            if (data.success) {
                setStatus('success');
            } else {
                setStatus('error');
                setErrorMessage(data.message || 'Не удалось отправить заявку');
            }
        } catch (err) {
            setStatus('error');
            setErrorMessage(err.message || 'Не удалось установить соединение с сервером');
        }
    };

    if (status === 'success') {
        return (
            <div className="form-container-box moto-offer-inline">
                <div className="form-header-zone">
                    <h1>Спасибо!</h1>
                    <p>Ваша заявка отправлена. Мы свяжемся с вами в ближайшее время.</p>
                </div>
                <Link to="/moto_models" className="get-offer-back-link">‹ Вернуться к моделям</Link>
            </div>
        );
    }

    return (
        <div className="form-container-box moto-offer-inline">
            <div className="form-header-zone">
                <h1>Получите предложение на BMW Motorrad</h1>
                <p>Заявка на приобретение мотоцикла</p>
            </div>
            <form className="premium-form" onSubmit={handleSubmit}>
                <div className="form-group-row">
                    <div className="input-field">
                        <label>Имя *</label>
                        <input type="text" name="first_name" value={form.first_name} onChange={handleChange} required />
                    </div>
                    <div className="input-field">
                        <label>Телефон *</label>
                        <input
                            type="tel"
                            name="phone"
                            value={form.phone}
                            onChange={handleChange}
                            placeholder="+998 XX XXX XX XX"
                            required
                        />
                    </div>
                </div>

                <div className="input-field">
                    <label>Какой мотоцикл вас интересует?</label>
                    <select name="interested_car" value={form.interested_car} onChange={handleChange}>
                        <option value="">Выберите вариант</option>
                        {motoOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                    </select>
                </div>

                {form.interested_car === 'other' && (
                    <div className="input-field">
                        <label>Укажите модель</label>
                        <input
                            type="text"
                            name="custom_car_name"
                            value={form.custom_car_name}
                            onChange={handleChange}
                            placeholder="Например: BMW R 1250 GS"
                        />
                    </div>
                )}
{/* 
                <div className="input-field">
                    <label>Способ приобретения</label>
                    <div className="get-offer-checkbox-group">
                        {PAYMENT_OPTIONS.map((option) => (
                            <label key={option} className="get-offer-checkbox-row">
                                <input
                                    type="radio"
                                    name="payment_method"
                                    value={option}
                                    checked={form.payment_method === option}
                                    onChange={handleChange}
                                />
                                <span>{option}</span>
                            </label>
                        ))}
                    </div>
                </div> */}

                <div className="input-field">
                    <label>Комментарий (необязательно)</label>
                    <textarea
                        name="comment"
                        value={form.comment}
                        onChange={handleChange}
                        rows={3}
                        placeholder="Например: интересует цвет, комплектация, сроки поставки"
                    />
                </div>

                <div className="get-offer-consent">
                    <input type="checkbox" required id="consent-moto" />
                    <label htmlFor="consent-moto">Я согласен на обработку персональных данных</label>
                </div>

                {status === 'error' && <p className="get-offer-error">{errorMessage}</p>}

                <button type="submit" className="form-submit-btn blue-theme" disabled={status === 'sending'}>
                    {status === 'sending' ? 'Отправка...' : 'Получить предложение'}
                </button>
            </form>
        </div>
    );
};

export default GetOfferMoto;